import { modalAnatomy as a } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as n, defineStyle as t } from "@chakra-ui/react";
import s from "../dataDisplay/closeButton.mjs";
const { defineMultiStyleConfig: r, definePartsStyle: d } = n(a.keys), m = t({
  bg: "blackAlpha.400",
  zIndex: "modal"
}), c = t((e) => {
  const { isCentered: o, scrollBehavior: i } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: o ? "center" : "flex-start",
    overflow: i === "inside" ? "hidden" : "auto"
  };
}), y = t((e) => {
  const { scrollBehavior: o } = e;
  return {
    borderRadius: "lg",
    bg: "white",
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: o === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: "xl",
    p: 6
  };
}), b = t({
  textStyle: "subheading2",
  mb: 2,
  pr: "44px"
}), f = t({
  ...s.baseStyle,
  position: "absolute",
  top: 6,
  right: 6
}), u = t((e) => {
  const { scrollBehavior: o } = e;
  return {
    textStyle: "body",
    flex: 1,
    overflow: o === "inside" ? "auto" : void 0
  };
}), x = t({
  mt: 6
}), S = d((e) => ({
  overlay: m,
  dialogContainer: c(e),
  dialog: y(e),
  header: b,
  closeButton: f,
  body: u(e),
  footer: x
})), l = (e) => e === "full" ? {
  dialog: {
    maxW: "100vw",
    minH: "100vh",
    "@supports(min-height: -webkit-fill-available)": {
      minH: "-webkit-fill-available"
    },
    my: 0,
    borderRadius: "none"
  }
} : {
  dialog: { maxW: e }
}, g = {
  sm: l("sm"),
  xl: l("xl"),
  full: l("full")
}, C = r({
  baseStyle: S,
  sizes: g,
  defaultProps: {
    size: "xl"
  }
});
export {
  C as default
};
